import { SelectIntegrationTypeWebController } from '../controller/SelectIntegrationTypeWebController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { License } from '../../integrationsGrid/types';

export class SelectIntegrationTypeWebComponent extends BaseWebComponentElement {
  public controller!: SelectIntegrationTypeWebController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: SelectIntegrationTypeWebController,
    });
  }
  set licenses(licenses: Array<License>) {
    this.setAttribute('data-licenses', JSON.stringify(licenses));
  }

  get licenses() {
    const value = this.getAttribute('data-licenses');
    return value ? JSON.parse(value) : [];
  }
}
